// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* login.css */

.login-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 75vw;
    margin: 0;
  }
  
  .login-container .card {
    width: 90%;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
  }
  
  .login-container .card .card-header {
    background-color: #007bff;
    color: #fff;
    padding: 15px;
    text-align: center;
    font-size: 18px;
  }
  
  .login-container .card .card-body {
    padding: 20px;
  }
  
  .login-container .card .card-body .form-group {
    margin-bottom: 20px;
  }
  
  .login-container .card .card-body .form-group label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .login-container .card .card-body .form-group .form-control {
    width: 100%;
    padding: 8px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  .login-container .card .card-body button {
    width: 100%;
    padding: 10px;
    background-color: #dc3545;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .login-container .card .card-body button:hover {
    background-color: #c82333;
  }
  
  .login-container .line {
    height: 3px;
    width: 30%;
    background-color: #007bff;
    margin: 20px auto;
  }

  .image-preview {
    width: 120px;
    height: 120px;
    overflow: hidden;
    border: 1px solid #ccc;
    border-radius: 50%;
  }

  .image-preview img {
    width: 100%; /* Make the image fill the container width */
    height: auto; /* Maintain the aspect ratio of the image */
    display: block; /* Remove default inline spacing */
  }
  
  /* Optional: Add some responsive styles */
  
  @media (max-width: 600px) {
    .login-container .card {
      width: 80%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/signIn/signin.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,SAAS;EACX;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW,EAAE,4CAA4C;IACzD,YAAY,EAAE,2CAA2C;IACzD,cAAc,EAAE,kCAAkC;EACpD;;EAEA,yCAAyC;;EAEzC;IACE;MACE,UAAU;IACZ;EACF","sourcesContent":["/* login.css */\n\n.login-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    width: 75vw;\n    margin: 0;\n  }\n  \n  .login-container .card {\n    width: 90%;\n    background-color: #fff;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  .login-container .card .card-header {\n    background-color: #007bff;\n    color: #fff;\n    padding: 15px;\n    text-align: center;\n    font-size: 18px;\n  }\n  \n  .login-container .card .card-body {\n    padding: 20px;\n  }\n  \n  .login-container .card .card-body .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .login-container .card .card-body .form-group label {\n    display: block;\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .login-container .card .card-body .form-group .form-control {\n    width: 100%;\n    padding: 8px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n  }\n  \n  .login-container .card .card-body button {\n    width: 100%;\n    padding: 10px;\n    background-color: #dc3545;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n  }\n  \n  .login-container .card .card-body button:hover {\n    background-color: #c82333;\n  }\n  \n  .login-container .line {\n    height: 3px;\n    width: 30%;\n    background-color: #007bff;\n    margin: 20px auto;\n  }\n\n  .image-preview {\n    width: 120px;\n    height: 120px;\n    overflow: hidden;\n    border: 1px solid #ccc;\n    border-radius: 50%;\n  }\n\n  .image-preview img {\n    width: 100%; /* Make the image fill the container width */\n    height: auto; /* Maintain the aspect ratio of the image */\n    display: block; /* Remove default inline spacing */\n  }\n  \n  /* Optional: Add some responsive styles */\n  \n  @media (max-width: 600px) {\n    .login-container .card {\n      width: 80%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
